// invoice/data/serviceInvoiceData.js
const serviceInvoiceData = {
  invoiceNumber: "INV-2026-005",
  invoiceDate: "15 Jan 2026",
  clientName: "Rohit Sharma",
  clientAddress: "Flat 502, Green Park Apartments, Sector 14, Noida, Uttar Pradesh, 201301",
  balanceDue: "₹18,400.00",
  items: [
    { id: 1, desc: "Brochure Design", subDesc: "Single sided (Color)", qty: 1, rate: 900, amount: 900 },
    { id: 2, desc: "Website Design Package", subDesc: "10 Pages, Slider, Free Logo", qty: 1, rate: 10000, amount: 10000 },
    { id: 3, desc: "Business Cards", subDesc: "Set of 100 Cards, Full Color", qty: 2, rate: 350, amount: 700 },
    { id: 4, desc: "Social Media Graphics", subDesc: "10 creatives for Instagram & FB", qty: 1, rate: 1800, amount: 1800 },
    { id: 5, desc: "Logo Design", subDesc: "Vector & Raster Files", qty: 1, rate: 3000, amount: 3000 },
  ],
  taxRate: 18 // GST %
};

export default serviceInvoiceData;
